
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';

import { MatInputModule, MatAutocompleteModule, MatSlideToggleModule, MatIconModule, MatButtonModule, MatSnackBarModule } from '@angular/material';

import { TitlebarComponent } from './titlebar.component';
import { ButtonreasonModule } from '../buttonreason/buttonreason.module';

@NgModule({
    imports: [
        BrowserModule, FormsModule, ReactiveFormsModule, BrowserAnimationsModule, CommonModule, BrowserModule, FormsModule, HttpModule,
        MatInputModule, MatAutocompleteModule, MatSlideToggleModule, MatIconModule, MatButtonModule, MatSnackBarModule,
        RouterModule, ButtonreasonModule
    ],
    entryComponents: [],
    exports: [
        TitlebarComponent
    ],
    declarations: [
        TitlebarComponent
    ],
    providers: [],
    bootstrap: []
})
export class TitlebarModule {
}
